import {
  Box,
  Popover,
  PopoverArrow,
  // PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  // PopoverHeader,
  PopoverTrigger,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { ColorResult, GithubPicker } from 'react-color';

interface IReactColorProps {
  selectedColor: string | undefined;
  colors: Array<any>;
  handleChange: (color: ColorResult) => void;
}

const ReactColor: React.FC<IReactColorProps> = ({ handleChange, selectedColor, colors }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);

  const handleClick = () => {
    setDisplayColorPicker(displayColorPicker => !displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  return (
    <Box position="relative">
      <Popover onClose={handleClose} isOpen={displayColorPicker} placement="top-start">
        <PopoverTrigger>
          <Box
            onClick={handleClick}
            display="inline-block"
            padding="1"
            background="white"
            borderRadius="base"
            boxShadow="base"
            cursor="pointer"
          >
            <Box width="40px" height="16px" borderRadius="2px" background={selectedColor} />
          </Box>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <GithubPicker
            width="100%"
            triangle="hide"
            color={selectedColor}
            styles={{ default: { card: { border: 'none', boxShadow: 'none' } } }}
            onChange={handleChange}
            colors={colors}
          />
        </PopoverContent>
      </Popover>
    </Box>
  );
};

export default ReactColor;
